import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3c4bbe34"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "grid-item-head" }
const _hoisted_2 = { class: "grid-item-head-title" }
const _hoisted_3 = { class: "grid-item-body grid-item-body-camera" }
const _hoisted_4 = ["src"]

import { ref, onMounted, onUnmounted } from 'vue'

type CameraPanelProps = {
  title: string
  path: string
  noImagePath: string
}


export default /*#__PURE__*/_defineComponent({
  props: {
    title: null,
    path: null,
    noImagePath: null
  },
  setup(__props: any) {

const props = __props as {
  title: string
  path: string
  noImagePath: string
}

const createPathWithTime = (path: string) => {
  return `${path}?t=${Date.now()}`
}

const INTERVAL = 1000 * 60 // 1minute

const imagePath = ref(createPathWithTime(props.path))
const timer = ref<number>()

const onError = () => {
  imagePath.value = props.noImagePath
}

onMounted(() => {
  timer.value = setInterval(() => {
    if (imagePath.value === props.noImagePath) {
      clearInterval(timer.value)

      return
    }

    imagePath.value = createPathWithTime(props.path)
  }, INTERVAL)
})

onUnmounted(() => {
  clearInterval(timer.value)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", _hoisted_2, _toDisplayString(__props.title), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("img", {
        src: imagePath.value,
        onerror: onError
      }, null, 8, _hoisted_4)
    ])
  ], 64))
}
}

})